import React from 'react';

const tools = [
  { name: 'Escore CURB-65', desc: 'Avaliação de gravidade em pneumonia' },
  { name: 'Critérios de Wells', desc: 'Probabilidade clínica de TEP e TVP' },
  { name: 'Escore HEART', desc: 'Estratificação de dor torácica aguda' },
  { name: 'Escala de Alvarado', desc: 'Diagnóstico de apendicite aguda' },
];

const Conversion = () => {
  return (
    <section className="conv">
      <form className="capture" onSubmit={(e) => e.preventDefault()}>
        <h3 className="capture__h">Guia de Bolso: Calculadoras Clínicas</h3>
        <p className="capture__sub">
          Material técnico com as principais tabelas e escores de emergência prontos para consulta
          rápida no plantão.
        </p>

        <div className="capture__field">
          <label className="capture__label" htmlFor="capture-email">
            E-mail profissional
          </label>
          <input
            id="capture-email"
            className="capture__input"
            type="email"
            placeholder="nome@instituicao.br"
            autoComplete="email"
          />
        </div>

        <label className="capture__check">
          <input type="checkbox" name="consent" />
          <span>
            Concordo em receber o material e li a{' '}
            <a href="/privacidade">Política de Privacidade</a>.
          </span>
        </label>

        <button type="submit" className="btn btn--pri">
          Acessar material
        </button>

        <p className="capture__note mono">Destinado a profissionais de saúde.</p>
      </form>

      <div className="conv__links">
        <h3 className="conv__h">Outras ferramentas recomendadas</h3>
        <dl className="rel">
          {tools.map((tool) => (
            <div className="rel__it" key={tool.name}>
              <dt className="rel__nm">{tool.name}</dt>
              <dd className="rel__ds">{tool.desc}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default Conversion;
